import React, { useState } from "react";
import { Alert, Form, InputGroup } from "react-bootstrap";
import InputMask from "react-input-mask";
import { handleWheel, handleKeyPress } from "../gridFunctions";
import search from "../../../../../assets/img/searchicon.png";
import { FieldArray } from "formik";
import { DbkField } from "../Elements/DbkField";
import moment from "moment";
import { DATA_ENTRY, EDIT_WORK, isActiveDbkField, QA_REVIEW } from "../../../../../functions";
import { async } from "@firebase/util";
import SweetAlert from "react-bootstrap-sweetalert";
import PlbPaginatedModal from "../../../../components/PlbPaginatedModal";
import PaginateSection from "../../../../components/PaginateSection";


const Eob = (props) => {
  const {
    formik,
    handleFloatValue,
    setcheckNum,
    totalPages,
    handleChangeIds,

    handlePLbFloatValue,
    handlePlbDeleteAmount,
    handlePlbAmount,
    insertRemainingAmount,

    __handlePayerLookupSearch,
    setPayerValue,
    setPayerFocus,
    payerFocus,

    __handlePayeeLookupSearch,
    setPayeeValue,
    setPayeeFocus,
    payeeFocus,

    cleareEobFocus,
    eobFocus,
    setEobFocus,
    handleFocusEob,
    addingNewEobClaimDbk,
    removeEobClaimDbk,
    isDbkPermission,
    jobData,
    qdxTransaction,
    isCheckNumber,
    setIsCheckNumber,
    isAlert,
    setIsAlert,
    isCorres835,
    isPP835,
    isSubJob,
    isFirstJob,
    job_id,
    log_id,
    isGeneratedCheckNumber,
    isPayerPage,
    isPayeePage,
    pdfLoaded,
    currentPage,
    disableCorresField,
    plbPaginatedata,
    setPlbPaginateData,
    handlePlbPageChange,
    handlePlbPaginatedCurrentPage

  } = props;
  const isViewOnllyGrid = true;
  const [options, setOptions] = useState(
    jobData?.correspondence_categories ? jobData?.correspondence_categories : []
  );
  const pathname = window.location.pathname;
  const gridData = jobData?.grid_data;
  const qaCorrectedData = gridData?.qa_corrected_data;


  const handleChangeCheckAmount = async (e) => {
    const value = e.target.value;
    if (value.includes(".") && value.split(".")[1].length > 2) {
      return;
    }



    await formik.setValues((prevState) => {

      if (e.target.value > 0 && qdxTransaction == "CORRESPONDENCE") {
        setIsAlert(true);
        return {
          ...prevState,
        };
      }

      if (window.location.pathname == DATA_ENTRY) {
        var payment_method = "";
        var check_number = "";
        if (parseFloat(value) == parseFloat(0) || parseFloat(value) == "") {
          if (qdxTransaction != "CORRESPONDENCE") {
            payment_method = "NON";

            if (isCheckNumber) {
              let num = Math.floor(Math.random() * 10000);

              // Convert the number to a 4-digit string with leading zeros if necessary
              num = num.toString().padStart(4, '0');
              if (isGeneratedCheckNumber) {
                check_number = "RX" + jobData?.grid_data?.timezone
              }

            }
            else {
              check_number = prevState?.check_number ? prevState?.check_number : ""
            }
          } else {
            payment_method = "COR";
            if (isCheckNumber) {
              let num = Math.floor(Math.random() * 10000);

              // Convert the number to a 4-digit string with leading zeros if necessary
              num = num.toString().padStart(4, '0');
              if (isGeneratedCheckNumber) {
                check_number = "LT" + jobData?.grid_data?.timezone
              }

            }
            else {
              check_number = prevState?.check_number ? prevState?.check_number : ""
            }
          }


        } else if (parseFloat(value) > parseFloat(0)) {
          payment_method = "CHK";

          check_number = prevState?.check_number ? prevState?.check_number : ""

        } else {
          payment_method = "ACH";
          if (isCheckNumber) {

            if (isGeneratedCheckNumber) {

              check_number = "RM" + jobData?.grid_data?.timezone

            }
          } else {
            check_number = prevState?.check_number ? prevState?.check_number : ""
          }
        }
        // Calculate remaining, paid_total, plb_total
        let remaining = 0;
        let paid_total = 0;
        let plb_total = 0;
        prevState?.claims?.map((claim, ind) => {
          paid_total =
            parseFloat(paid_total ? paid_total : 0) +
            parseFloat(claim.claim_paid ? claim.claim_paid : 0);
        });

        prevState?.plb_adjustments?.map((plb, ind) => {
          plb_total =
            parseFloat(paid_total ? plb_total : 0) +
            parseFloat(plb?.plb_amt ? plb?.plb_amt : 0);
        });

        remaining = parseFloat(
          parseFloat(value ? value : 0) -
          parseFloat(paid_total ? paid_total : 0) +
          parseFloat(plb_total ? plb_total : 0)
        ).toFixed(2);

        // extra protection for minus value
        if (remaining == -0.0) {
          remaining = parseFloat(0).toFixed(2);
        }

        return {
          ...prevState,
          check_amount: e.target.value,
          payment_method: payment_method,
          remaining_balance: remaining,
          dbk_check_number: check_number,
          check_number: check_number,
        };
      } else {


        let remaining = 0;
        let paid_total = 0;
        let plb_total = 0;
        prevState?.claims?.map((claim, ind) => {
          paid_total =
            parseFloat(paid_total ? paid_total : 0) +
            parseFloat(claim.claim_paid ? claim.claim_paid : 0);
        });

        prevState?.plb_adjustments?.map((plb, ind) => {
          plb_total =
            parseFloat(paid_total ? plb_total : 0) +
            parseFloat(plb?.plb_amt ? plb?.plb_amt : 0);
        });

        remaining = parseFloat(
          parseFloat(value ? value : 0) -
          parseFloat(paid_total ? paid_total : 0) +
          parseFloat(plb_total ? plb_total : 0)
        ).toFixed(2);

        // extra protection for minus value
        if (remaining == -0.0) {
          remaining = parseFloat(0).toFixed(2);
        }

        return {
          ...prevState,
          check_amount: e.target.value,
          remaining_balance: remaining,
        };
      }
    });

  }

  const handleInputPaymentMethod = async (e) => {

    let check_data = "";

    if (e.target.value == "COR" && qdxTransaction != "CORRESPONDENCE") {
      setIsAlert(true)
      // alert('INVALID TRANSACTION TYPE')
      return
    } else if (e.target.value != "COR" && qdxTransaction == "CORRESPONDENCE") {
      setIsAlert(true)
      return
    }

    else {

      if (isCheckNumber && window.location.pathname == DATA_ENTRY) {

        if (e.target.value == "ACH") {
          let num = Math.floor(Math.random() * 10000);

          // Convert the number to a 4-digit string with leading zeros if necessary
          num = num.toString().padStart(4, '0');
          if (isGeneratedCheckNumber) {

            check_data = "RM" + jobData?.grid_data?.timezone
          }
        }
        if (e.target.value == "VCP") {

          check_data = formik.values?.check_number ? formik.values?.check_number : ""

        }
        if (e.target.value == "CHK") {

          check_data = formik.values?.check_number ? formik.values?.check_number : ""

        }
        if (e.target.value == "NON") {
          let num = Math.floor(Math.random() * 10000);
          // Convert the number to a 4-digit string with leading zeros if necessary
          num = num.toString().padStart(4, '0');
          if (isGeneratedCheckNumber) {

            check_data = "RX" + jobData?.grid_data?.timezone
          }
        }
        if (e.target.value == "OTH") {
          let num = Math.floor(Math.random() * 10000);
          // Convert the number to a 4-digit string with leading zeros if necessary
          num = num.toString().padStart(4, '0');
          if (isGeneratedCheckNumber) {

            check_data = "RX" + jobData?.grid_data?.timezone
          }
        }
        if (e.target.value == "CCI") {
          let num = Math.floor(Math.random() * 10000);
          // Convert the number to a 4-digit string with leading zeros if necessary
          num = num.toString().padStart(4, '0');
          if (isGeneratedCheckNumber) {

            check_data = "CI" + jobData?.grid_data?.timezone
          }
        }
        if (e.target.value == "COR") {
          let num = Math.floor(Math.random() * 10000);
          // Convert the number to a 4-digit string with leading zeros if necessary
          num = num.toString().padStart(4, '0');
          if (isGeneratedCheckNumber) {

            check_data = "LT" + jobData?.grid_data?.timezone
          }
        }
        // console.log(check_data, ':::::::::::::::::::::::::::');

        await formik.setValues({
          ...formik.values,
          check_number: check_data,
          dbk_check_number: check_data,
          payment_method: e.target.value,
        })

      }
      else {
        await formik.setValues({
          ...formik.values,
          payment_method: e.target.value,
        })
      }
    }
  }

  const handleChangeFromTo = async (e) => {
    if (!e.target.disabled) {
      await formik.setValues((prevState) => {
        return {
          ...prevState,
          [e.target.name]: currentPage + 1,
        }
      })
    }
  }

  const handleCheckNumber = (e) => {
    if (e.target.value.length > 0) {
      setIsCheckNumber(false)
    }
    else {
      setIsCheckNumber(true)
    }
    formik.handleChange(e)
  }
  const renderClass = (name, type, defaultClass) => {
    if (formik.errors?.[name]) {
      return defaultClass + ' error-field'
    }
    if (pathname == QA_REVIEW) {

      if (qaCorrectedData &&
        qaCorrectedData?.[name]) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'DATE' && moment(formik.values?.[name]).format("MM/DD/YYYY") != moment(gridData?.[name]).format("MM/DD/YYYY")) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'TEXT' && formik.values?.[name]?.toUpperCase() !=
        gridData?.[name]?.toUpperCase()) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'NUMBER' && parseFloat(formik.values?.[name] ? formik.values?.[name] : 0).toFixed(2) !=
        parseFloat(gridData?.[name] ?
          gridData?.[name] : 0).toFixed(2)) {
        return defaultClass + ' qa-field'
      }
      else if (gridData?.transaction_type != "PAYMENT835") {
        return defaultClass + ' qa-field'
      }


      else if (type == 'DATE' && formik.values?.[name] &&
        formik.values?.data_837 &&
        formik.values?.data_837[0] &&
        formik.values?.data_837[0]?.[name] &&
        formik.values?.[name]?.toUpperCase() ==
        formik.values?.data_837[0]?.[name].toUpperCase()) {
        return defaultClass + ' data-837'
      }
      else if (type == 'TEXT' && formik.values?.[name] &&
        formik.values?.data_837 &&
        formik.values?.data_837[0] &&
        formik.values?.data_837[0]?.[name] &&
        formik.values?.[name]?.toUpperCase() ==
        formik.values?.data_837[0]?.[name].toUpperCase()) {
        return defaultClass + ' data-837'
      }
      else if (type == 'NUMBER' && formik.values?.[name] &&
        formik.values?.data_837 &&
        formik.values?.data_837[0] &&
        formik.values?.data_837[0]?.[name] &&
        formik.values?.[name] ==
        formik.values?.data_837[0]?.[name]) {
        return defaultClass + ' data-837'
      }
      else {
        return defaultClass;
      }


    }
    else if ((pathname == EDIT_WORK + job_id || pathname == EDIT_WORK + job_id + "?log_id=" + log_id) && qaCorrectedData && qaCorrectedData?.[name]) {
      return defaultClass + ' qa-field'
    }
    else if (type == 'DATE' && formik.values?.[name] &&
      formik.values?.data_837 &&
      formik.values?.data_837[0] &&
      formik.values?.data_837[0]?.[name] &&
      formik.values?.[name]?.toUpperCase() ==
      formik.values?.data_837[0]?.[name].toUpperCase()) {
      return defaultClass + ' data-837'
    }
    else if (type == 'TEXT' && formik.values?.[name] &&
      formik.values?.data_837 &&
      formik.values?.data_837[0] &&
      formik.values?.data_837[0]?.[name] &&
      formik.values?.[name]?.toUpperCase() ==
      formik.values?.data_837[0]?.[name].toUpperCase()) {
      return defaultClass + ' data-837'
    }
    else if (type == 'NUMBER' && formik.values?.[name] &&
      formik.values?.data_837 &&
      formik.values?.data_837[0] &&
      formik.values?.data_837[0]?.[name] &&
      formik.values?.[name] ==
      formik.values?.data_837[0]?.[name]) {
      return defaultClass + ' data-837'
    }
    else {
      return defaultClass;
    }
  }
  const renderPlbClass = (name, type, defaultClass, index) => {
    if (formik.errors &&
      formik.errors?.plb_adjustments &&
      formik.errors?.plb_adjustments[index] &&
      formik.errors?.plb_adjustments[index]?.[name]) {
      return defaultClass + ' error-field'
    }
    if (pathname == QA_REVIEW) {

      if (qaCorrectedData &&
        qaCorrectedData?.plb_adjustments &&
        qaCorrectedData?.plb_adjustments[index] &&
        qaCorrectedData?.plb_adjustments[index]?.[name]) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'DATE' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index] &&
        moment(formik.values?.plb_adjustments[index]?.[name]).format("MM/DD/YYYY") != moment(gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index]?.[name]).format("MM/DD/YYYY")) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'TEXT' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index] &&
        formik.values?.plb_adjustments[index]?.[name]?.toUpperCase() !=
        gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index]?.[name]?.toUpperCase()) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'STRING' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index] &&
        formik.values?.plb_adjustments[index]?.[name] !=
        gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index]?.[name]) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'NUMBER' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index] &&
        parseFloat(formik.values?.plb_adjustments[index]?.[name] ? formik.values?.plb_adjustments[index]?.[name] : 0).toFixed(2) !=
        parseFloat(gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index]?.[name] ?
          gridData?.plb_adjustments[formik.values?.plb_adjustments[index]?.plb_index ? formik.values?.plb_adjustments[index]?.plb_index : formik.values?.plb_adjustments[index]?.plb_index == 0 ? formik.values?.plb_adjustments[index]?.plb_index : index]?.[name] : 0).toFixed(2)) {
        return defaultClass + ' qa-field'
      }

      if (formik.values?.plb_adjustments[index]?.corrected_plb || gridData?.transaction_type != "PAYMENT835") {
        return defaultClass + ' qa-field'
      }

      else {
        return defaultClass;
      }


    }
    else if ((pathname == EDIT_WORK + job_id || pathname == EDIT_WORK + job_id + "?log_id=" + log_id) &&
      qaCorrectedData &&
      qaCorrectedData?.plb_adjustments &&
      qaCorrectedData?.plb_adjustments[index] &&
      qaCorrectedData?.plb_adjustments[index]?.[name]) {
      return defaultClass + ' qa-field'
    }

    else {
      return defaultClass;
    }
  }
  return (
    <React.Fragment>

      <div
        className="topblock-wrapper eob_block accordion-collapse  collapse show"
        id="collapseOne"
        aria-labelledby="headingOne"
        data-bs-parent="#payment835"
      >
        <div className="sub-job-eob">
          <div className="sub-section">
            <div className="">
              <label className="btn btn-payment835">Payment835</label>
            </div>
            <div className="paymentmethod-wi">
              <InputGroup>
                <InputGroup.Text>Payment Method</InputGroup.Text>
                <Form.Control
                  as="select"
                  name="payment_method"
                  // onChange={formik.handleChange}
                  onChange={(e) => handleInputPaymentMethod(e)}
                  value={formik.values?.payment_method}
                  id="payment_method"
                  className={renderClass('payment_method', 'TEXT', 'selc-bg-1 ps-1  first-row-grid')}

                >
                  <option
                    value=""
                    disabled={
                      formik.values?.check_amount > parseFloat(0) ||
                      formik.values?.check_amount == parseFloat(0)
                    }
                  >
                    Select an Option
                  </option>
                  <option value="ACH">ACH</option>
                  <option
                    value="CHK"
                    selected={formik.values?.check_amount > parseFloat(0)}
                  >
                    CHK
                  </option>
                  <option
                    value="NON"
                    selected={formik.values?.check_amount == parseFloat(0)}
                  >
                    NON
                  </option>
                  <option
                    value="VCP"
                  >
                    VCP
                  </option>
                  {isCorres835 || isPP835 ?
                    <React.Fragment>

                      <option
                        value="OTH"
                        selected={formik.values?.check_amount == parseFloat(0)}
                      >
                        OTH
                      </option>
                      <option
                        value="CCI"
                        selected={formik.values?.check_amount == parseFloat(0)}
                      >
                        CCI
                      </option>
                      {isCorres835 &&
                        <option
                          value="COR"
                          selected={formik.values?.check_amount == parseFloat(0)}
                        >
                          COR
                        </option>
                      }
                    </React.Fragment>
                    : ""
                  }
                </Form.Control>
              </InputGroup>
            </div>
            <div className="checknum-wi">
              <InputGroup>
                <InputGroup.Text>Check Number</InputGroup.Text>
                <div className="dbk-main-container">
                  <Form.Control
                    type="text"
                    className={renderClass('check_number', 'TEXT', 'w-78 first-row-grid')}

                    onChange={(e) => {
                      handleCheckNumber(e)
                    }}
                    value={formik.values?.check_number}
                    onFocus={() => {
                      handleFocusEob("check_number", "main", null, isDbkPermission?.payment?.payment_check_number);
                    }}
                    name="check_number"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_check_number) ? !eobFocus.check_number : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}

                  />

                  {
                    isDbkPermission?.payment?.payment_check_number &&
                      formik.errors?.check_number === "Dont Match" &&
                      eobFocus.check_number ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="text"
                        fieldName="check_number"
                        fieldNameDbk="dbk_check_number"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                </div>
              </InputGroup>
            </div>
            <div className="checkdate-wi">
              <InputGroup>
                <InputGroup.Text>Check Date</InputGroup.Text>
                <div className="dbk-main-container">
                  <InputMask
                    mask="99/99/9999"
                    className={renderClass('check_date', 'DATE', 'w-48 first-row-grid')}

                    style={{ fontSize: "0.7em" }}
                    onChange={formik.handleChange}
                    value={formik.values?.check_date}
                    placeholder={"mm/dd/yyyy"}
                    onFocus={() => {
                      handleFocusEob("check_date", "main", null, isDbkPermission?.payment?.payment_check_date);
                    }}
                    name="check_date"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_check_date) ? !eobFocus.check_date : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}

                  />
                  {
                    isDbkPermission?.payment?.payment_check_date &&
                      formik.errors?.check_date === "Dont Match" &&
                      eobFocus.check_date ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="date"
                        fieldName="check_date"
                        fieldNameDbk="dbk_check_date"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                </div>
              </InputGroup>
            </div>
            <div className="checkamt-wi">
              <InputGroup>
                <InputGroup.Text>Check Amount</InputGroup.Text>
                <div className="dbk-main-container">
                  <Form.Control
                    type="number"
                    min="0.00"
                    onWheel={handleWheel}
                    aria-describedby="empty"
                    onChange={(e) => handleChangeCheckAmount(e)}
                    onFocus={() => {
                      handleFocusEob("check_amount", "main", null, isDbkPermission?.payment?.payment_check_amount);
                    }}
                    onKeyDown={handleKeyPress}
                    value={formik.values?.check_amount}
                    onBlur={(e) => handleFloatValue(e, "check_amount", null)}
                    className={renderClass('check_amount', 'NUMBER', 'w-78 text-end first-row-grid')}

                    name="check_amount"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_check_amount) ? !eobFocus.check_amount : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}


                  />
                  {isDbkPermission?.payment?.payment_check_amount &&
                    formik.errors?.check_amount == "Dont Match" &&
                    eobFocus.check_amount ? (
                    <DbkField
                      formik={formik}
                      index=""
                      fieldType="main"
                      type="number"
                      fieldName="check_amount"
                      fieldNameDbk="dbk_check_amount"
                      setCorresPondanceFocus={setEobFocus}
                      corresPondanceFocus={eobFocus}
                    />
                  ) : null}
                </div>
              </InputGroup>
            </div>
            <div className="remainingbln-wi">
              <InputGroup>
                <InputGroup.Text>Remaining Balance</InputGroup.Text>
                <Form.Control
                  type="number"
                  disabled
                  onChange={formik.handleChange}
                  onWheel={handleWheel}
                  id="remaining_balance_check"
                  value={parseFloat(formik.values?.remaining_balance).toFixed(2)}
                  className={
                    !!formik.errors?.remaining_balance
                      ? "w-100 error-field text-end"
                      : "w-100 text-end"
                  }
                  name="remaining_balance"
                />
              </InputGroup>
            </div>
            <div className="ChkPgNo-wi">
              <InputGroup>
                <InputGroup.Text>ChkPgNo</InputGroup.Text>
                <Form.Control
                  type="number"
                  min="1"
                  onChange={(e) => {
                    formik.handleChange(e);
                    setcheckNum(e.target.value);
                  }}
                  onWheel={handleWheel}
                  value={formik.values?.check_page_number}
                  className={renderClass('check_page_number', 'NUMBER', 'w-82 first-row-grid')}

                  disabled={isSubJob}
                  data-corress-disable={disableCorresField('check_page_number')}
                  name="check_page_number"
                />
              </InputGroup>
            </div>
          </div>
          <div className="sub-section">
            <div className="">
              <label className="btn btn-payer">Payer </label>
            </div>
            <div className="wrapper-payer">
              <InputGroup>
                <InputGroup.Text>
                  Name
                  {!isSubJob || isFirstJob && isSubJob || !isFirstJob && !isSubJob ?
                    <a
                      type="button"
                      className="payersearch"
                    // disabled={isSubJob ? true : false}


                    >
                      <img src={search} alt="" />
                    </a>
                    :
                    <React.Fragment>

                    </React.Fragment>
                  }
                </InputGroup.Text>
                <div className="dbk-main-container">
                  <Form.Control

                    type="text"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleChangeIds(e, "payer");
                      setPayerValue(e.target.value);
                    }}
                    onFocus={(e) => {
                      handleFocusEob("payer_name", "main", null, isDbkPermission?.payment?.payment_payer_name);
                      setPayerFocus(true);
                      setPayerValue(e.target.value);
                    }}
                    onBlur={() => setPayerFocus(false)}
                    value={formik.values?.payer_name}
                    autoFocus={payerFocus}
                    // style={
                    //   formik.values?.payer_name &&
                    //     formik.values?.data_837 &&
                    //     formik.values?.data_837[0] &&
                    //     formik.values?.data_837[0]?.payer_name &&
                    //     formik.values?.payer_name?.toUpperCase() ==
                    //     formik.values?.data_837[0]?.payer_name.toUpperCase()
                    //     ? { backgroundColor: "#65a1b4", color: "#fff !important" }
                    //     : {}
                    // }
                    tabIndex={
                      formik.values?.payer_name &&
                      formik.values?.data_837 &&
                      formik.values?.data_837[0] &&
                      formik.values?.data_837[0]?.payer_name?.toUpperCase() &&
                      formik.values?.payer_name ==
                      formik.values?.data_837[0]?.payer_name?.toUpperCase() &&
                      "-1"
                    }
                    autoComplete={"off"}
                    className={renderClass('payer_name', 'TEXT', 'w-payer text-uppercase')}

                    name="payer_name"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payer_name) ? !eobFocus.payer_name : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}

                  />
                  {isDbkPermission?.payment?.payment_payer_name &&
                    formik.errors?.payer_name == "Dont Match" &&
                    eobFocus.payer_name ? (
                    <DbkField
                      formik={formik}
                      index=""
                      fieldType="main"
                      type="text"
                      fieldName="payer_name"
                      fieldNameDbk="dbk_payer_name"
                      setCorresPondanceFocus={setEobFocus}
                      corresPondanceFocus={eobFocus}
                    />
                  ) : null}
                </div>
              </InputGroup>
            </div>
            <div className="wrapper-add">
              <InputGroup>
                <InputGroup.Text>Address</InputGroup.Text>
                <div className="dbk-main-container">
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleChangeIds(e, "payer");
                    }}
                    autoComplete={"off"}
                    onFocus={(e) => {
                      handleFocusEob("payer_address", "main", null, isDbkPermission?.payment?.payment_payer_address);
                    }}
                    value={formik.values?.payer_address}
                    // style={
                    //   formik.values?.payer_address &&
                    //     formik.values?.data_837 &&
                    //     formik.values?.data_837[0] &&
                    //     formik.values?.data_837[0]?.payer_address &&
                    //     formik.values?.payer_address ==
                    //     formik.values?.data_837[0]?.payer_address
                    //     ? { backgroundColor: "#65a1b4", color: "#fff !important" }
                    //     : {}
                    // }
                    tabIndex={
                      formik.values &&
                      formik.values?.payer_address &&
                      formik.values?.data_837 &&
                      formik.values?.data_837[0] &&
                      formik.values?.data_837[0]?.payer_address &&
                      formik.values?.payer_address?.toUpperCase() ==
                      formik.values?.data_837[0]?.payer_address?.toUpperCase() &&
                      "-1"
                    }
                    className={renderClass('payer_address', 'TEXT', 'w-address')}

                    name="payer_address"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payer_address) ? !eobFocus.payer_address : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                    data-corress-disable={disableCorresField('payer_address')}
                  />
                  {isDbkPermission?.payment?.payment_payer_address &&
                    formik.errors?.payer_address == "Dont Match" &&
                    eobFocus.payer_address ? (
                    <DbkField
                      formik={formik}
                      index=""
                      fieldType="main"
                      type="text"
                      fieldName="payer_address"
                      fieldNameDbk="dbk_payer_address"
                      setCorresPondanceFocus={setEobFocus}
                      corresPondanceFocus={eobFocus}
                    />
                  ) : null}
                </div>
              </InputGroup>
            </div>
            <div className="wrap">
              <InputGroup>
                <InputGroup.Text>City</InputGroup.Text>
                <div className="dbk-main-container">
                  <Form.Control

                    type="text"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleChangeIds(e, "payer");
                    }}
                    autoComplete={"off"}
                    onFocus={(e) => {
                      handleFocusEob("payer_city", "main", null, isDbkPermission?.payment?.payment_payer_city);
                    }}
                    value={formik.values?.payer_city}

                    tabIndex={
                      formik.values?.payer_city &&
                      formik.values?.data_837 &&
                      formik.values?.data_837[0] &&
                      formik.values?.data_837[0]?.payer_city &&
                      formik.values?.payer_city?.toUpperCase() ==
                      formik.values?.data_837[0]?.payer_city?.toUpperCase() &&
                      "-1"
                    }
                    className={renderClass('payer_city', 'TEXT', 'w-82')}

                    name="payer_city"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payer_city) ? !eobFocus.payer_city : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                    data-corress-disable={disableCorresField('payer_city')}
                  />
                  {isDbkPermission?.payment?.payment_payer_city &&
                    formik.errors?.payer_city == "Dont Match" &&
                    eobFocus.payer_city ? (
                    <DbkField
                      formik={formik}
                      index=""
                      fieldType="main"
                      type="text"
                      fieldName="payer_city"
                      fieldNameDbk="dbk_payer_city"
                      setCorresPondanceFocus={setEobFocus}
                      corresPondanceFocus={eobFocus}
                    />
                  ) : null}
                </div>
              </InputGroup>
            </div>
            <div className="wrap">
              <InputGroup>
                <InputGroup.Text>State</InputGroup.Text>
                <div className="dbk-main-container">
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleChangeIds(e, "payer");
                    }}
                    autoComplete={"off"}
                    onFocus={(e) => {
                      handleFocusEob("payer_state", "main", null, isDbkPermission?.payment?.payment_payer_state);
                    }}
                    maxLength="2"
                    value={formik.values?.payer_state}

                    tabIndex={
                      formik.values &&
                        formik.values?.payer_state &&
                        formik.values?.data_837 &&
                        formik.values?.data_837[0] &&
                        formik.values?.data_837[0]?.payer_state &&
                        formik.values?.payer_state?.toUpperCase() ==
                        formik.values?.data_837[0]?.payer_state?.toUpperCase() ?
                        "-1" : ""
                    }
                    className={renderClass('payer_state', 'TEXT', 'w-82')}

                    name="payer_state"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payer_state) ? !eobFocus.payer_state : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                    data-corress-disable={disableCorresField('payer_state')}
                  />
                  {isDbkPermission?.payment?.payment_payer_state &&
                    formik.errors?.payer_state == "Dont Match" &&
                    eobFocus.payer_state ? (
                    <DbkField
                      formik={formik}
                      index=""
                      fieldType="main"
                      type="text"
                      fieldName="payer_state"
                      fieldNameDbk="dbk_payer_state"
                      setCorresPondanceFocus={setEobFocus}
                      corresPondanceFocus={eobFocus}
                    />
                  ) : null}
                </div>
              </InputGroup>
            </div>
            <div className="wrap">
              <InputGroup>
                <InputGroup.Text>Zip</InputGroup.Text>
                <div className="dbk-main-container">
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleChangeIds(e, "payer");
                    }}
                    autoComplete={"off"}
                    onFocus={(e) => {
                      handleFocusEob("payer_zip", "main", null, isDbkPermission?.payment?.payment_payer_zip);
                    }}
                    maxLength={10}
                    value={formik.values?.payer_zip}
                    // style={
                    //   formik.values?.payer_zip &&
                    //     formik.values?.data_837 &&
                    //     formik.values?.data_837[0] &&
                    //     formik.values?.data_837[0]?.payer_zip &&
                    //     formik.values?.payer_zip ==
                    //     formik.values?.data_837[0]?.payer_zip
                    //     ? { backgroundColor: "#65a1b4", color: "#fff !important" }
                    //     : {}
                    // }
                    tabIndex={
                      formik.values?.payer_zip &&
                      formik.values?.data_837 &&
                      formik.values?.data_837[0] &&
                      formik.values?.data_837[0]?.payer_zip &&
                      formik.values?.payer_zip ==
                      formik.values?.data_837[0]?.payer_zip &&
                      "-1"
                    }
                    className={renderClass('payer_zip', 'TEXT', 'w-82')}

                    name="payer_zip"
                    disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payer_zip) ? !eobFocus.payer_zip : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                    data-corress-disable={disableCorresField('payer_zip')}
                  />
                  {isDbkPermission?.payment?.payment_payer_zip &&
                    formik.errors?.payer_zip == "Dont Match" &&
                    eobFocus.payer_zip ? (
                    <DbkField
                      formik={formik}
                      index=""
                      fieldType="main"
                      type="text"
                      fieldName="payer_zip"
                      fieldNameDbk="dbk_payer_zip"
                      setCorresPondanceFocus={setEobFocus}
                      corresPondanceFocus={eobFocus}
                    />
                  ) : null}
                </div>
              </InputGroup>
            </div>
            {isPayerPage &&
              <div className="d-flex flex-row">
                <div className="">
                  <InputGroup>
                    <InputGroup.Text>From</InputGroup.Text>
                    <Form.Control
                      type="number"
                      min={1}
                      name="payer_page_from"
                      // onBlur={handleCurrentPageChange}
                      // onClick={handleChangeFrom}
                      disabled={true}
                      onChange={formik.handleChange}
                      onWheel={handleWheel}
                      // onFocus={() => setClaim835Focus(true)}
                      onClick={(e) => {
                        handleChangeFromTo(e);
                      }}
                      onFocus={(e) => {
                        handleChangeFromTo(e);
                      }}
                      value={formik.values?.payer_page_from}
                      // tabIndex={colorAll837 && all837?.from ? "-1": ""}

                      className={renderClass('payer_page_from', 'NUMBER', 'pagefrom')}

                    />
                  </InputGroup>
                </div>
                <div className="">
                  <InputGroup>
                    <InputGroup.Text>To</InputGroup.Text>
                    <Form.Control
                      type="number"
                      name="payer_page_to"
                      min={1}
                      disabled={true}
                      onWheel={handleWheel}
                      onChange={formik.handleChange}
                      onClick={(e) => {
                        handleChangeFromTo(e);
                      }}
                      onFocus={(e) => {
                        // setClaim835Focus(true);
                        handleChangeFromTo(e);
                      }}
                      value={formik.values?.payer_page_to}
                      // tabIndex={colorAll837 && all837?.to ? "-1": ""}

                      className={renderClass('payer_page_to', 'NUMBER', 'pageto')}

                    />
                  </InputGroup>
                </div>
              </div>
            }

          </div>
          <div className="master-bottom-section">
            <div className="sub-section">
              <div className="">
                <label className="btn btn-payer">Payee </label>
              </div>
              <div className="wrapper-payer">
                <InputGroup>
                  <InputGroup.Text>
                    Name{" "}
                    {!isSubJob || isFirstJob && isSubJob || !isFirstJob && !isSubJob ?

                      <a className="payersearch" >
                        <img src={search} alt="" />
                      </a>
                      :
                      <React.Fragment>

                      </React.Fragment>
                    }
                  </InputGroup.Text>
                  <div className="dbk-main-container">
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleChangeIds(e, "payee");
                        setPayeeValue(e.target.value);
                      }}
                      onFocus={(e) => {
                        setPayeeValue(e.target.value);
                      }}
                      onBlur={() => setPayeeFocus(false)}
                      className={renderClass('payee_name', 'TEXT', 'w-payer')}

                      autoFocus={payeeFocus}

                      // style={
                      //   formik.values?.payee_name &&
                      //     formik.values?.data_837 &&
                      //     formik.values?.data_837[0] &&
                      //     formik.values?.data_837[0]?.payee_name &&
                      //     formik.values?.payee_name?.toUpperCase() ==
                      //     formik.values?.data_837[0].payee_name.toUpperCase()
                      //     ? { backgroundColor: "#65a1b4", color: "#fff !important" }
                      //     : {}
                      // }

                      tabIndex={
                        formik.values?.payee_name &&
                        formik.values?.data_837 &&
                        formik.values?.data_837[0] &&
                        formik.values?.data_837[0]?.payee_name &&
                        formik.values?.payee_name?.toUpperCase() ==
                        formik.values?.data_837[0]?.payee_name?.toUpperCase() &&
                        "-1"
                      }

                      value={formik.values?.payee_name}

                      name="payee_name"
                      disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payee_name) ? !eobFocus.payee_name : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}

                    />
                    {isDbkPermission?.payment?.payment_payee_name &&
                      formik.errors?.payee_name == "Dont Match" &&
                      eobFocus.payee_name ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="text"
                        fieldName="payee_name"
                        fieldNameDbk="dbk_payee_name"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                  </div>
                </InputGroup>
              </div>

              <div className="wrapper-add">
                <InputGroup>
                  <InputGroup.Text>NPI</InputGroup.Text>
                  <div className="dbk-main-container">
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleChangeIds(e, "payee");
                      }}

                      tabIndex={
                        formik.values?.payee_npi &&
                        formik.values?.data_837 &&
                        formik.values?.data_837[0] &&
                        formik.values?.data_837[0]?.payee_npi &&
                        formik.values?.payee_npi ==
                        formik.values?.data_837[0]?.payee_npi &&
                        "-1"
                      }
                      maxLength={10}
                      onFocus={() => {
                        handleFocusEob("payee_npi", "main", null, isDbkPermission?.payment?.payment_payee_npi);
                      }}
                      value={formik.values?.payee_npi}
                      className={renderClass('payee_npi', 'TEXT', 'w-address')}

                      name="payee_npi"
                      disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payee_npi) ? !eobFocus.payee_npi : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}

                    />
                    {isDbkPermission?.payment?.payment_payee_npi &&
                      formik.errors?.payee_npi == "Dont Match" &&
                      eobFocus.payee_npi ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="text"
                        fieldName="payee_npi"
                        fieldNameDbk="dbk_payee_npi"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                  </div>
                </InputGroup>
              </div>
              <div className="wrapper-add">
                <InputGroup>
                  <InputGroup.Text>Address</InputGroup.Text>
                  <div className="dbk-main-container">
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleChangeIds(e, "payee");
                      }}
                      onFocus={() => {
                        handleFocusEob("payee_address", "main", null, isDbkPermission?.payment?.payment_payee_address);
                      }}

                      tabIndex={
                        formik.values?.payee_address &&
                        formik.values?.data_837 &&
                        formik.values?.data_837[0] &&
                        formik.values?.data_837[0]?.payee_address &&
                        formik.values?.payee_address?.toUpperCase() ==
                        formik.values?.data_837[0]?.payee_address?.toUpperCase() &&
                        "-1"
                      }
                      value={formik.values?.payee_address}

                      name="payee_address"
                      className={renderClass('payee_address', 'TEXT', 'w-address')}

                      disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payee_address) ? !eobFocus.payee_address : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                      data-corress-disable={disableCorresField('payee_address')}
                    />
                    {isDbkPermission?.payment?.payment_payee_address &&
                      formik.errors?.payee_address == "Dont Match" &&
                      eobFocus.payee_address ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="text"
                        fieldName="payee_address"
                        fieldNameDbk="dbk_payee_address"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                  </div>
                </InputGroup>
              </div>
              <div className="wrap">
                <InputGroup>
                  <InputGroup.Text>City</InputGroup.Text>
                  <div className="dbk-main-container">
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleChangeIds(e, "payee");
                      }}
                      onFocus={() => {
                        handleFocusEob("payee_city", "main", null, isDbkPermission?.payment?.payment_payee_city);
                      }}

                      tabIndex={
                        formik.values?.payee_city &&
                        formik.values?.data_837 &&
                        formik.values?.data_837[0] &&
                        formik.values?.data_837[0]?.payee_city &&
                        formik.values?.payee_city?.toUpperCase() ==
                        formik.values?.data_837[0]?.payee_city?.toUpperCase() &&
                        "-1"
                      }
                      value={formik.values?.payee_city}
                      className={renderClass('payee_city', 'TEXT', 'w-82')}

                      name="payee_city"
                      disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payee_city) ? !eobFocus.payee_city : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                      data-corress-disable={disableCorresField('payee_city')}
                    />
                    {isDbkPermission?.payment?.payment_payee_city &&
                      formik.errors?.payee_city == "Dont Match" &&
                      eobFocus.payee_city ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="text"
                        fieldName="payee_city"
                        fieldNameDbk="dbk_payee_city"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                  </div>
                </InputGroup>
              </div>
              <div className="wrap">
                <InputGroup>
                  <InputGroup.Text>State</InputGroup.Text>
                  <div className="dbk-main-container">
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleChangeIds(e, "payee");
                      }}
                      onFocus={() => {
                        handleFocusEob("payee_state", "main", null, isDbkPermission?.payment?.payment_payee_state);
                      }}
                      className={renderClass('payee_state', 'TEXT', 'w-82')}

                      tabIndex={
                        formik.values?.payee_state &&
                        formik.values?.data_837 &&
                        formik.values?.data_837[0] &&
                        formik.values?.data_837[0]?.payee_state &&
                        formik.values?.payee_state?.toUpperCase() ==
                        formik.values?.data_837[0]?.payee_state?.toUpperCase() &&
                        "-1"
                      }
                      maxLength={2}
                      value={formik.values?.payee_state}

                      name="payee_state"
                      disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payee_state) ? !eobFocus.payee_state : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                      data-corress-disable={disableCorresField('payee_state')}
                    />
                    {isDbkPermission?.payment?.payment_payee_state &&
                      formik.errors?.payee_state == "Dont Match" &&
                      eobFocus.payee_state ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="text"
                        fieldName="payee_state"
                        fieldNameDbk="dbk_payee_state"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                  </div>
                </InputGroup>
              </div>
              <div className="wrap">
                <InputGroup>
                  <InputGroup.Text>Zip</InputGroup.Text>
                  <div className="dbk-main-container">
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleChangeIds(e, "payee");
                      }}
                      onFocus={() => {
                        handleFocusEob("payee_zip", "main", null, isDbkPermission?.payment?.payment_payee_zip);
                      }}
                      className={renderClass('payee_zip', 'TEXT', 'w-82')}

                      tabIndex={
                        formik.values?.payee_zip &&
                        formik.values?.data_837 &&
                        formik.values?.data_837[0] &&
                        formik.values?.data_837[0]?.payee_zip &&
                        formik.values?.payee_zip ==
                        formik.values?.data_837[0]?.payee_zip &&
                        "-1"
                      }
                      maxLength={10}
                      value={formik.values?.payee_zip}

                      name="payee_zip"
                      disabled={isActiveDbkField(eobFocus, formik, isDbkPermission?.payment?.payment_payee_zip) ? !eobFocus.payee_zip : !isSubJob && isFirstJob ? true : isSubJob && !isFirstJob ? true : false}
                      data-corress-disable={disableCorresField('payee_zip')}
                    />
                    {isDbkPermission?.payment?.payment_payee_zip &&
                      formik.errors?.payee_zip == "Dont Match" &&
                      eobFocus.payee_zip ? (
                      <DbkField
                        formik={formik}
                        index=""
                        fieldType="main"
                        type="text"
                        fieldName="payee_zip"
                        fieldNameDbk="dbk_payee_zip"
                        setCorresPondanceFocus={setEobFocus}
                        corresPondanceFocus={eobFocus}
                      />
                    ) : null}
                  </div>
                </InputGroup>
              </div>
              {isPayeePage &&
                <div className="d-flex flex-row">
                  <div className="">
                    <InputGroup>
                      <InputGroup.Text>From</InputGroup.Text>
                      <Form.Control
                        type="number"
                        min={1}
                        name="payee_page_from"
                        disabled={true}
                        onChange={formik.handleChange}
                        onWheel={handleWheel}
                        onClick={(e) => {
                          handleChangeFromTo(e);
                        }}
                        onFocus={(e) => {
                          handleChangeFromTo(e);
                        }}
                        value={formik.values?.payee_page_from}
                        className={renderClass('payee_page_from', 'NUMBER', 'pagefrom')}

                      />
                    </InputGroup>
                  </div>
                  <div className="">
                    <InputGroup>
                      <InputGroup.Text>To</InputGroup.Text>
                      <Form.Control
                        disabled={true}

                        type="number"
                        name="payee_page_to"
                        min={1}
                        data-disabled={true}
                        onWheel={handleWheel}
                        onChange={formik.handleChange}
                        onClick={(e) => {
                          handleChangeFromTo(e);
                        }}
                        onFocus={(e) => {
                          // setClaim835Focus(true);
                          handleChangeFromTo(e);
                        }}
                        value={formik.values?.payee_page_to}
                        // tabIndex={colorAll837 && all837?.to ? "-1": ""}
                        className={renderClass('payee_page_to', 'NUMBER', 'pageto')}


                      />
                    </InputGroup>
                  </div>
                </div>
              }
              {formik?.values?.plb_adjustments?.length>plbPaginatedata?.pageSize&&
                <div className="plb-pgination-container-section">
                  <PaginateSection handlePlbPageChange={handlePlbPageChange} plbPaginatedata={plbPaginatedata} data={formik?.values?.plb_adjustments} />
                </div>
              }
            </div>
          </div>
        </div>

        <React.Fragment>
          <PlbPaginatedModal handlePlbPageChange={handlePlbPageChange} handlePlbPaginatedCurrentPage={handlePlbPaginatedCurrentPage} componentType='PAYMENT835' plbPaginatedata={plbPaginatedata} setPlbPaginateData={setPlbPaginateData} formik={formik} handleWheel={handleWheel} handlePlbDeleteAmount={handlePlbDeleteAmount} renderPlbClass={renderPlbClass} setPlbOnFocus={null} plbOnFocus={null} handlePlbAmount={handlePlbAmount} handleKeyPress={handleKeyPress} insertRemainingAmount={insertRemainingAmount} handlePLbFloatValue={handlePLbFloatValue} isViewOnllyGrid={isViewOnllyGrid} totalPages ={totalPages}/>
        </React.Fragment>

      </div >
    </React.Fragment >
  );
};

export default Eob;
